var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 18,
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.8a5.4 5.4 0 0 0-5.4 5.4v3.227l-.636.636A.9.9 0 0 0 3.6 12.6h10.8a.9.9 0 0 0 .637-1.537l-.637-.636V7.2A5.4 5.4 0 0 0 9 1.8zM9 16.2a2.7 2.7 0 0 1-2.7-2.7h5.4A2.7 2.7 0 0 1 9 16.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotify);
export default __webpack_public_path__ + "static/media/notify.be638a9d1cc0b1dfd1ed6bd76a112865.svg";
export { ForwardRef as ReactComponent };